<template>
    <div class="wrapper">
        <div class="content-wrapper">
            <div class="category-list">
                <header class="header">
                    <h3>分类列表</h3>
                    <el-button size="small" type="primary" class="add-btn" @click="popAddBox('add')">新增分类</el-button>
                </header>

                <!-- 分类列表 -->
                <el-table
                        v-loading="tableLoading"
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="createTime"
                            label="创建时间">
                        <template slot-scope="scope">
                            {{timeFormat(scope.row.create_at)}}
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="sort_name"
                            label="分类名称">
                    </el-table-column>

                    <el-table-column
                            label="操作"
                            width="250">
                        <template slot-scope="scope">
                            <el-button v-show="scope.row.sort_name != '默认分类'" @click="popDelBox(scope.row)" type="text"
                                       size="small">删除
                            </el-button>
                            <el-button v-show="scope.row.sort_name != '默认分类'" type="text" size="small"
                                       @click="popAddBox('edit', scope.row)">编辑
                            </el-button>
                            <!--<el-button type="text" v-show="!scope.row.shared && scope.row.sort_name != '默认分类'"-->
                                       <!--size="small" @click="popShareBox(scope.row, 'share')">分享该分类-->
                            <!--</el-button>-->
                            <!--<el-button type="text" v-show="scope.row.shared" size="small"-->
                                       <!--@click="popShareBox(scope.row, 'cancel')">取消分享-->
                            <!--</el-button>-->
                            <!--<el-button type="text" v-show="scope.row.shared" size="small"-->
                                       <!--@click="popShareBox(scope.row, 'copy')">复制分享链接-->
                            <!--</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--<div class="category-manage">-->
                <!--<header>-->
                    <!--<h3>分类管理</h3>-->
                    <!--<small>点击分类设置为默认加载的分类</small>-->
                <!--</header>-->
                <!--<el-radio-group v-model="selecetedId" @change="changeDefault">-->
                    <!--<el-radio class="radio-button" v-for="item in setTableData" :label="item.sort_id"-->
                              <!--:key="item.sort_id" border>{{item.sort_name}}-->
                    <!--</el-radio>-->
                <!--</el-radio-group>-->

            <!--</div>-->
            <!-- 删除分类 -->
            <el-dialog
                    :visible.sync="delBox"
                    :before-close="handleDelCancel"
                    title="删除分类"
                    width="50%">
                <p class="title">删除分类后该分类下的图片将自动归类到“默认分类”中</p>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleDelCancel">取 消</el-button>
                    <el-button type="primary" @click="handleDel">确 定</el-button>
                </span>
            </el-dialog>

            <!-- 新增、编辑分类弹框 -->
            <el-dialog
                    :visible.sync="dialogVisible"
                    :before-close="handleCancel"
                    width="50%">
                <div slot="title">{{title}}</div>
                <el-input maxlength=14   minlength=1   v-model="sortName" placeholder="请输入分类名称"></el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleCancel">取 消</el-button>
                    <el-button type="primary" @click="handleSort">确 定</el-button>
                </span>
            </el-dialog>

            <!-- 分享弹框 -->
            <el-dialog
                    :visible.sync="shareBox"
                    :before-close="handleShareCancel"
                    width="60%">
                <div slot="title">分享成功</div>
                <el-input v-model="shareLink" disabled>
                    <el-button slot="append" type="primary" @click="copyLink">复制链接</el-button>
                </el-input>
                <p class="tips">温馨提示：该链接仅分享该分类当前包含的所有图片，后续上传至该分类的图片不会被自动分享</p>
            </el-dialog>


        </div>
    </div>
</template>
<script>
  import {Message, Loading} from 'element-ui';
  import Common from './assets/scripts/common.js';


  export default {
    name: 'category',
    data() {
      return {
        tableData: [],
        setTableData: [],
        dialogVisible: false,
        sortName: '',
        handleType: '', //操作分类的类型 'add'新增分类 'edit'编辑分类
        title: '',
        delBox: false,
        delData: {},
        tableLoading: true,
        // 分享相关变量
        shareBox: false, //分享弹框显示
        shareLink: {}, //分享链接
        selecetedId: "" //默认加载的分类ID
      }
    },
    methods: {
      //新增/编辑分类
      handleSort: function () {
        let that = this;
        let handleType = this.handleType;
        let sortName = (this.sortName || '').replace(/\s/g, '');
        if (sortName && handleType == 'add') {
          lib.tmsapi.post({
            api: 'api/test/sort/add',
            data: {
              sortName: sortName
            },
            success: (res) => {
              // 提示成功
              Message.success({
                message: '添加分类成功',
                type: 'info',
                center: true
              });
              // 添加成功，刷新列表
              that.getSortList('update');

              // 关闭弹框
              that.dialogVisible = false;
              // 清楚输入框内容
              that.sortName = ''
            },
          })

        }

        if (sortName && handleType == 'edit') {

          lib.tmsapi.post({
            api: 'api/test/sort/add',
            data: {
              sortName: sortName,
              sortId: that.sortId
            },
            success: (res) => {
              // 提示成功
              Message.success({
                message: '修改分类成功',
                type: 'info',
                center: true
              });
              // 修改成功，刷新列表
              that.getSortList('update');

              // 关闭弹框
              that.dialogVisible = false;
              // 清楚输入框内容
              that.sortName = '';
              // 清楚handleType
              that.handleType = '';
            },

          })
        }
      },
      // dialog取消按钮更改状态
      handleCancel: function () {
        this.dialogVisible = false;
        this.handleType = '';
        this.sortName = '';
        this.sortId = '';
      }
      ,

      // 点击新增/编辑弹框
      popAddBox: function (type, data) {
        if (!this.dialogVisible) {
          this.dialogVisible = true;
          this.handleType = type;
        }

        if (type == "edit") {
          this.title = "编辑分类";
          this.sortName = data.sort_name;
          this.sortId = data.sort_id;
        }

        if (type == "add") {
          this.title = "新增分类";
        }
      }
      ,

      // 分享该分类
      popShareBox: function (data, type) {
        this.tableLoading = true;
        switch (type) {
          case 'share':
            let sortId = data.sort_id;
            lib.tmsapi.post({
              api: 'api/test/sort/share',
              data: {
                shared: true,
                sortId: sortId
              },
              success: (res) => {
                this.tableLoading = false;
                // 提示成功
                Message.success({
                  message: '分享分类成功',
                  type: 'info',
                  center: true
                });
                // 修改成功，刷新列表
                this.getSortList('get');
              },
            })

            break;

          case 'cancel':
            lib.tmsapi.post({
              api: 'api/test/sort/share',
              data: {
                shared: false,
                sortId: data.sort_id
              },
              success: (res) => {
                this.tableLoading = false;
                // 提示成功
                Message.success({
                  message: '取消分享分类成功',
                  type: 'info',
                  center: true
                });
                // 修改成功，刷新列表
                this.getSortList('get');
              },
            })
            break;

          case 'copy':
            let url = location.origin+'/pic?sort_id='+data.sort_id;
            const input = document.createElement('input');
            document.body.appendChild(input);
            input.setAttribute('value', url);
            input.setAttribute('display', "none");
            input.select();
            if (document.execCommand('copy')) {
              document.execCommand('copy');
              Message.success({
                message: '已复制',
                type: 'info',
                center: true
              });
              this.tableLoading = false;
            }
            document.body.removeChild(input);
        }
      }
      ,

      // 复制分享链接功能
      copyLink: function () {

      }
      ,

      // 隐藏分享弹框
      handleShareCancel: function () {
        this.shareBox = false;
      }
      ,

      // 获取分类列表
      getSortList: function () {

        lib.tmsapi.get({
          api: 'api/test/sort/list',
          data: {},
          success: (res) => {
            if (res.data) {
              this.tableLoading = false;
              this.tableData = res.data || [];
              this.setTableData = [{sort_id: "", sort_name: "全部"}, ...this.tableData];
              this.selecetedId = '';
            }
          },
        })

      },


      // 点击删除弹框
      popDelBox: function (data) {
        console.log(data);
        if (!this.delBox) {
          this.delData = {...data};
          this.delBox = true;
        }
      }
      ,
      // 取消删除
      handleDelCancel: function () {
        this.delBox = false;
        this.delData = {};
      }
      ,

      // 删除一条分类
      handleDel: function (data) {
        let that = this;
        let sortId = this.delData.sort_id;
        let params = {
          sortId: sortId
        };
        if (!sortId) {
          return false;
        }

        lib.tmsapi.post({
          api: 'api/test/sort/del',
          data: params,
          success: (res) => {
            // 关闭弹框
            that.delBox = false;
            Message.success({
              message: '删除分类成功',
              type: 'info',
              center: true
            });
            // 添加成功，刷新列表
            that.getSortList('update');
          },
        })

      }
      ,

      // 时间戳格式化
      timeFormat: function (date) {
        return Common.formatTime(date);
      }
    },
    mounted() {
      // this.getSortList({
      //     sortName: '',
      //     sortId: ''
      // });
      this.getSortList('get');
    }
  }
</script>
<style scoped>
    .header {
      display: flex;
      background: #fff;
      padding: 10px;
      margin: 0 0 10px 0 !important;
    }
    .content-wrapper {
        margin: 20px auto;
        width: 70%;
    }

    .title {
        text-align: center;
        font-size: 16px;
    }

    .tips {
        font-size: 12px;
        padding-top: 10px;
        line-height: 18px;
        color: rgb(64, 158, 255);
    }

    .category-list header {
        display: flex;
        align-items: center;
        margin: 10px;
    }

    .category-list header h3 {
        flex: 1;
    }

    .category-manage {
        margin-top: 30px;
    }

    .category-manage header {
        display: flex;
        align-items: center;
        margin: 10px;
    }

    .category-manage small {
        font-size: 12px;
        color: #bbb;
        padding-left: 5px;
    }

    .category-manage .radio-button {
        margin: 0 10px 10px 10px;
        width: 150px;
        text-align: center;

    }
</style>

